export default "__VITE_ASSET__CaHtzIgz__"